import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SportsSchedule from "../pages/sports-schedule/page";
import LiveScore from "../pages/live-score/page";
import Lineup from "../pages/lineup/page";
import MissingPlayers from "../pages/missing-players/page";
import SpeedSports from "../pages/speed-sports/page";
import Sports4K from "../pages/4k-sports/page";
import LiveTV from "../pages/live-tv/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sports-schedule",
    element: <SportsSchedule />,
  },
  {
    path: "/live-score",
    element: <LiveScore />,
  },
  {
    path: "/lineup",
    element: <Lineup />,
  },
  {
    path: "/missing-players",
    element: <MissingPlayers />,
  },
  {
    path: "/speed-sports",
    element: <SpeedSports />,
  },
  {
    path: "/4k-sports",
    element: <Sports4K />,
  },
  {
    path: "/live-tv",
    element: <LiveTV />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;